import { type AxiosResponse } from 'axios';
import { type z } from 'zod';

export function parseResponse<TResponse>(res: AxiosResponse, schema: z.ZodType<TResponse>, unwrap: boolean): TResponse {
  const data: unknown = unwrap ? ((res.data as { data: TResponse })?.data ?? res.data) : res.data;

  if (data === null || data === undefined) {
    throw new Error('No data received from API');
  }

  const result = schema.safeParse(data);

  if (!result.success) {
    console.error(
      'Schema validation failed:',
      result.error.issues.map((i) => `${i.path.join('.')}: ${i.message}`)
    );
    throw new Error(`Schema validation failed: ${result.error.message}`);
  }

  return result.data;
}
